
import React from "react";
function Navbar(){
    return(


        <nav className="py-4 bg-gray-800">
         <h1 className="text-3xl font-bold text-center text-white">TOP COURSES</h1>
        </nav>
        
    );
}
export default Navbar;